import { css, styled } from '@mui/material';

export const StyledOnboardingSlideControls = styled('div')(
  ({ theme }) => css`
    margin-top: ${theme.spacing('1XL')};
  `
);

export const StyledOnboardingCard = styled('div')(
  ({ theme }) => css`
    display: flex;
    justify-content: flex-start !important;
    flex-direction: column !important;
    text-align: center;
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: ${theme.spacing('LARGE')};
    padding-left: ${theme.spacing('LARGE')};
  `
);
